import React from 'react';
import { Stack, Box, MobileStepper, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const Video = styled('video')({
  maxWidth: '100%',
  maxHeight: `400px`,
});

export default function Carusel(props) {
  const {images} = props;
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = images.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Stack sx={{ mt: 2}}>
      <Stack>
        {images && images.length > activeStep && (
            images?.[activeStep]?.videoPath ?
            <Stack align>
              <Video id="video_U" src={images?.[activeStep]?.videoPath} controls autoPlay playsInline loop />
              <Box sx={{ mt: 2, fontWeight: 'bold' }}>{images?.[activeStep]?.label}</Box>
              <Box sx={{ p: 1, }}>{images?.[activeStep]?.description}</Box>
            </Stack>
                :
              <Stack align>
                <Box
                  component="img"
                  sx={{
                    height: 400,
                    objectFit: 'contain',
                    display: 'block',
                    // maxWidth: 400,
                    overflow: 'hidden',
                    width: '100%',
                  }}
                  src={images?.[activeStep]?.imgPath}
                  alt={images?.[activeStep]?.label}
                />
                <Box sx={{ mt: 2, fontWeight: 'bold' }}>{images?.[activeStep]?.label}</Box>
                <Box sx={{ p: 1, }}>{images?.[activeStep]?.description}</Box>
              </Stack>
        )}
          <MobileStepper
            steps={maxSteps}
            position="static"
            activeStep={activeStep}
            nextButton={
              <Button
                size="small"
                onClick={handleNext}
                disabled={activeStep === maxSteps - 1}
              >
                Siguiente &#62;
              </Button>
            }
            backButton={
              <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                &#60; Atrás
              </Button>
            }
        />
      </Stack>
    </Stack>
  );
}
